import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=4ccdcc1a&scoped=true"
import script from "./EditGroup.vue?vue&type=script&lang=ts"
export * from "./EditGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccdcc1a",
  null
  
)

export default component.exports